import React, { createContext, useState, useCallback, useContext } from 'react';

import { api } from '../middlewares';

import { ContextGetData } from './getData';

import translateVector from '../Utils/translator';
import {
  translateTodasSolicitacoes,
  translateGetSolicitacaoSemAgendamento,
  translateGetSolicitacao,
  translateAgendamentosAbertos,
  translateBuilding,
  translateType,
} from '../Utils/translateFunctions';

import { useHistory } from 'react-router-dom';
import { dataToBlob } from '../Utils/dataToBlob';

const ContextSolicitacoes = createContext();

function Solicitacoes({ children }) {
  const { atualizaAgendamentosAbertos } = useContext(ContextGetData);

  const [periodoAgente, setPeriodoAgente] = useState([]);

  const [apontamentos, setApontamentos] = useState([]);

  const [listaApontamentosOriginal, setListaApontamentosOriginal] = useState(
    []
  );

  const [loading, setLoading] = useState(true);

  const [motivoSelecionado, setMotivoSelecionado] = useState('');

  const [apontamentoSelecionado, setApontamentoSelecionado] = useState(
    `Selecione uma categoria de apontamento que melhor descreva o seu reparo.`
  );

  const [resetApontamentoMotivo, setResetApontamentoMotivo] = useState(false);

  const [solicitacoes, setSolicitacoes] = useState([]);

  const [loadingSolicitacoes, setLoadingSolicitacoes] = useState(true);

  const [solicitacoesParaExibir, setSolicitacoesParaExibir] = useState([]);

  const [listaDeImoveis, setListaDeImoveis] = useState([]);

  const [imovelSolicitacao, setImovelSolicitacao] = useState('');

  const [loadingImoveis, setLoadingImoveis] = useState(true);

  const [tiposSolicitacoes, setTiposSolicitacoes] = useState([]);

  const [listaApontamentosSelecionado, setListaApontamentosSelecionado] =
    useState([]);

  const [listaMotivoSelecionado, setlistaMotivoSelecionado] = useState([]);

  // Thiago
  const [removedDocuments, setRemovedDocuments] = useState([]);
  //end Thiago

  const history = useHistory();

  async function getSolicitacoes() {
    let result = '';
    try {
      result = await api.get('Solicitacao/GetSolicitacoes');
      return translateVector(result.data, translateTodasSolicitacoes);
    } catch (error) {
      return error.request;
    }
  }

  async function getAllSolicitacoes() {
    return api.get('Solicitacao/GetSolicitacoes');
  }

  async function getApontamentos() {
    if (listaApontamentosOriginal?.length > 0) return listaApontamentosOriginal;

    let result = '';
    try {
      result = await api.get('Solicitacao/Apontamentos');

      return result.data;
    } catch (error) {
      return error;
    }
  }

  async function getSolicitacao(idSolicitacao) {
    let resultGetSolicitacao = '';
    try {
      resultGetSolicitacao = await api.get('Solicitacao/GetSolicitacao', {
        params: {
          id: idSolicitacao,
        },
      });

      if (resultGetSolicitacao.data.CompromissoServico == null) {
        return translateVector(
          resultGetSolicitacao.data,
          translateGetSolicitacaoSemAgendamento
        );
      } else {
        return translateVector(
          resultGetSolicitacao.data,
          translateGetSolicitacao
        );
      }
    } catch (error) {
      return error.request;
    }
  }

  async function getAnexoSolicitacao(solicitacao) {
    try {
      let response = await api.get('Solicitacao/GetAnexoSolicitacao', {
        params: {
          caseId: solicitacao?.id,
          assisTec: solicitacao?.subgrupo === 'AT_INCORPORACAO' ? true : false,
        },
      });

      if (response.status >= 200 && response.status < 300) {
        return response.data;
      }
    } catch (error) {
      return error.request;
    }
  }

  async function getAgendamentosAbertos() {
    let result = '';
    let temp = '';
    try {
      result = await api.get('Solicitacao/AgendamentosAbertos');
      temp = translateVector(result.data, translateAgendamentosAbertos);

      return temp;
    } catch (error) {
      return false;
    }
  }

  async function getTipoSolicitacoes() {
    if (tiposSolicitacoes?.length > 0) return tiposSolicitacoes;

    try {
      const result = await api.get('Solicitacao/TiposSolicitacao');

      let temp = translateVector(result.data, translateType);

      temp.push({
        tipo: 'Outros',
        tipoSalesForce: 'Outros',
        geraAgendamento: false,
      });

      setTiposSolicitacoes(temp);
      return temp;
    } catch (error) {
      return error;
    }
  }

  async function getImoveisParaSolicitacoes() {
    let result = '';
    try {
      result = await api.get('Solicitacao/GetImoveis', {
        params: { validaContratoInadimplente: true },
      });

      let r = translateVector(result.data, translateBuilding);

      return r;
    } catch (error) {
      return [];
    }
  }

  async function cancelarSolicitacao(id, agendamento) {
    try {
      await api.patch(
        'Solicitacao/CancelarSolicitacao',
        {},
        {
          params: {
            id: id,
            agendamento: agendamento,
          },
        }
      );
      await atualizaAgendamentosAbertos();
      return true;
    } catch (error) {
      return false;
    }
  }

  async function getPeriodoAgente(tipoSolicitacao, assetId) {
    try {
      let result = await api.get('Solicitacao/GetPeriodoAgente', {
        params: {
          tipo_solicitacao: tipoSolicitacao,
          assetId: assetId,
        },
      });
      setPeriodoAgente(result.data);
      return result.data;
    } catch (error) {
      return error.response.data.Falha;
    }
  }

  async function getVerificaAgendamento(tipoSolicitacao, assetId) {
    try {
      let result = await api.get('Solicitacao/VerificaSolicitacaoAgendamento', {
        params: {
          tipo_solicitacao: tipoSolicitacao,
          imovel_id: assetId,
        },
      });

      return result;
    } catch (error) {
      return error.response;
    }
  }

  const criarSolicitacao = async (solicitacao) => {
    let resultPostSolicitacao = '';
    try {
      resultPostSolicitacao = await api.post('Solicitacao/CriarSolicitacao', {
        ...solicitacao,
      });

      return translateVector(
        resultPostSolicitacao.data.result,
        translateGetSolicitacaoSemAgendamento
      );
    } catch (error) {
      return false;
    }
  };

  const saveFiles = async (userDocuments, caseId) => {
    let formData = new FormData();

    formData.append('CaseId', caseId);

    let fileSizeInMb = 0;

    const sendDocuments = async () => {
      try {
        let response;

        if (formData.get('Anexos')) {
          response = await api.post(
            `Solicitacao/PostAnexoSolicitacao?validarSolicitacao=true`,
            formData
          );
        }

        if (response) return response;
      } catch (error) {
        return false;
      }
    };

    const getExtension = (file) => {
      if (file?.url === undefined) {
        // verifica se não é uma imagem que veio pela API
        if (file?.type !== undefined) {
          return `.${file.type.split('/')[1]}`;
        } else if (file?.includes('application/pdf')) {
          return '.pdf';
        } else if (file?.includes('video/mp4')) {
          return '.mp4';
        } else if (file?.includes('video/webm')) {
          return '.webm';
        } else if (file?.includes('video/avi')) {
          return '.avi';
        } else if (file?.includes('video/mkv')) {
          return '.mkv';
        }
      }
    };

    const verifyExtension = async (file, workTypeId) => {
      if (file.url === undefined) {
        // verifica se não é uma imagem que veio pela API
        let fileName =
          workTypeId === null || workTypeId === undefined
            ? `imagem${getExtension(file)}`
            : `_ReparoID_${workTypeId}${getExtension(file)}`;

        if (typeof file === 'string') {
          formData.append('Anexos', dataToBlob(file), fileName);
        } else {
          formData.append('Anexos', file, fileName);
        }
      }
    };

    const getSumOfSizes = async (file, workTypeId) => {
      let currentFileSize = 0;

      if (typeof file === 'string') {
        currentFileSize += dataToBlob(file).size / 1024 / 1024;
      } else {
        currentFileSize += file.size / 1024 / 1024;
      }

      if (currentFileSize + fileSizeInMb < 30) {
        fileSizeInMb += currentFileSize;

        await verifyExtension(file, workTypeId);
      } else {
        await sendDocuments();

        formData.delete('Anexos');

        fileSizeInMb += currentFileSize;

        await verifyExtension(file, workTypeId);
      }
    };

    for (let i = 0; i < userDocuments?.length; i++) {
      if (
        userDocuments[i]?.documents === undefined &&
        userDocuments[i]?.apontamento
      ) {
        continue;
      }

      if (userDocuments[i]?.documents === undefined) {
        await getSumOfSizes(userDocuments[i], null);
      } else {
        for (let j = 0; j < userDocuments[i]?.documents.length; j++) {
          await getSumOfSizes(
            userDocuments[i]?.documents[j],
            userDocuments[i]?.workTypeId
          );
        }
      }
    }

    await sendDocuments();
  };

  const removeFiles = async (documents, caseId) => {
    documents?.forEach(async (document) => {
      try {
        let response = await api.delete(`Solicitacao/ExcluirAnexoSolicitacao`, {
          params: {
            caseId: caseId,
            chaveS3: document.idAws,
          },
        });

        if (response) return response;
      } catch (error) {
        return false;
      }
    });
  };

  //end Thiago

  const aceiteTermoAgendamento = async (
    caseNumber,
    caseIdSalesForce,
    subgrupo
  ) => {
    try {
      await api.post('Solicitacao/AceitarTermo', {
        caseNumber,
        caseIdSalesForce,
        subgrupo,
      });
    } catch (error) {
      return false;
    }
  };

  const editAssistenciaTecnica = async (apontamentosEdicao) => {
    try {
      await api.put('Solicitacao/PutApontamento', {
        ...apontamentosEdicao,
      });
    } catch (error) {
      return false;
    }
  };

  const criarAgendamento = async (agendamento) => {
    let resultPostAgendamento = '';
    try {
      resultPostAgendamento = await api.post(
        'Solicitacao/CriarAgendamento',
        {
          ...agendamento,
        },
        {}
      );
      await atualizaAgendamentosAbertos();
      return translateVector(
        resultPostAgendamento.data.result,
        translateGetSolicitacao
      );
    } catch (error) {
      return error.request;
    }
  };

  function getSolicitacaoUnica(id) {
    history.push({
      pathname: `/solicitacoes/acompanhar-solicitacao/${id}`,
    });
  }

  async function loadApontamentos(apontamentosAntigos) {
    setLoading(true);
    let arrayItensApontamentos = [];
    let resultadoGetApontamentos;

    try {
      // get da lista de todos apontamentos
      resultadoGetApontamentos = await getApontamentos();
      resultadoGetApontamentos.forEach((apontamento) => {
        arrayItensApontamentos.push({
          nome: apontamento.Descricao,
          id: apontamento.Descricao,
          idSalesForce: apontamento.IdSalesForce,
        });
      });
      setListaApontamentosOriginal(resultadoGetApontamentos);
      if (apontamentosAntigos)
        removeApontamentosAntigos(arrayItensApontamentos, apontamentosAntigos);
      else {
        setApontamentos(arrayItensApontamentos);
      }
      setLoading(false);
    } catch (error) {
      return error;
    }

    // guarda a lista de apontamentos original

    // seta a lista de apontamentos para o dropdown
    // setApontamentos(arrayItensApontamentos.sort(dynamicSort("nome")));
  }

  const removeApontamentosAntigos = (
    apontamentosNovos,
    apontamentosAntigos
  ) => {
    let filtered = undefined;

    apontamentosAntigos.forEach((antigo) => {
      if (filtered) {
        filtered = filtered.filter((filt) => filt.nome != antigo.apontamento);
      } else
        filtered = apontamentosNovos.filter(
          (novo) => novo.nome != antigo.apontamento
        );
    });

    setApontamentos(filtered.sort(dynamicSort('nome')));
  };

  function loadMotivos() {
    let arrayTemporarioMotivos = [];
    let arrayMotivos;
    try {
      arrayMotivos = listaApontamentosOriginal.filter(filtraMotivos);
      arrayMotivos[0].ApontamentoMotivos.forEach((motivo) => {
        arrayTemporarioMotivos.push({
          nome: motivo.Descricao,
          id: motivo.Descricao,
          idSalesForce: motivo.IdSalesForce,
          prazoDias: motivo.PrazoDias,
        });
      });
    } catch (error) {
      return error;
    }

    setlistaMotivoSelecionado(arrayTemporarioMotivos.sort(dynamicSort('nome')));

    if (arrayTemporarioMotivos.length === 1)
      setMotivoSelecionado(arrayTemporarioMotivos[0].nome);
  }

  function filtraMotivos(apontamento) {
    return apontamento.Descricao == apontamentoSelecionado;
  }

  function dynamicSort(property) {
    let sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      let result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  function removeMotivo(motivo) {
    let resultRemoveMotivo = listaApontamentosSelecionado.filter(
      (motiv) => motiv.idSalesForce !== motivo.idSalesForce
    );

    setListaApontamentosSelecionado(resultRemoveMotivo);

    for (let index = 0; index < listaApontamentosOriginal.length; index++) {
      if (
        listaApontamentosOriginal[index].Descricao ==
        motivo.apontamentoSelecionado
      ) {
        listaApontamentosOriginal[index].ApontamentoMotivos.push({
          Descricao: motivo.motivoSelecionado,
          IdSalesForce: motivo.idSalesForce,
          PrazoDias: motivo.prazoDias,
        });

        listaApontamentosOriginal[index].ApontamentoMotivos.sort(
          dynamicSort('descricao')
        );
      }
    }
    setlistaMotivoSelecionado('');
    setResetApontamentoMotivo(true);
  }

  const minhasSolicitacoes = useCallback(async () => {
    let resultGet = {};
    let finalSolicitacoes = {};
    try {
      resultGet = await getAllSolicitacoes();
      finalSolicitacoes = translateVector(
        resultGet.data,
        translateTodasSolicitacoes
      );

      setSolicitacoes(finalSolicitacoes);

      setSolicitacoesParaExibir(finalSolicitacoes);
    } catch {
      setSolicitacoes([]);

      setSolicitacoesParaExibir([]);
    } finally {
      setLoadingSolicitacoes(false);
    }
  });

  async function loadImoveisDisponiveis() {
    let imoveisDisponiveis = [];
    try {
      let resultImoveisDisponiveis = await getImoveisParaSolicitacoes();

      console.log('resultImoveisDisponiveis', resultImoveisDisponiveis);

      resultImoveisDisponiveis?.forEach((imovel) => {
        imoveisDisponiveis.push({
          assetId: imovel.assetIdSalesFoce,
          id: imovel.id,
          nome: imovel.NomeImovel,
          tipo: imovel.empreendimento.holding.nome,
          contratos: imovel.contratos,
          contratoInadimplente: imovel.contratoInadimplente,
          idVenda: imovel.idVenda,
          imovel: {
            Bloqueio: imovel.Bloqueio,
            CodigosUAU: imovel.CodigosUAU,
            CodigoObra: imovel.CodigoObra,
            serviceTerritoryId: imovel.empreendimento.TerritorioServico,
            EntregaChave: imovel.EntregaChave,
          },
          empreendimento: {
            ...imovel.empreendimento,
            DataEntrega: imovel.empreendimento.DataEntrega,
          },
        });
      });

      setListaDeImoveis(imoveisDisponiveis);

      if (imoveisDisponiveis?.length === 1)
        setImovelSolicitacao(imoveisDisponiveis[0].nome);

      setLoadingImoveis(false);
    } catch (error) {
      return error.request;
    }
  }

  return (
    <ContextSolicitacoes.Provider
      value={{
        getSolicitacoes,
        getSolicitacao,
        getAnexoSolicitacao,
        getTipoSolicitacoes,
        getApontamentos,
        cancelarSolicitacao,
        criarSolicitacao,
        getImoveisParaSolicitacoes,
        getPeriodoAgente,
        getVerificaAgendamento,
        criarAgendamento,
        getAgendamentosAbertos,
        periodoAgente,
        getSolicitacaoUnica,
        editAssistenciaTecnica,
        loadApontamentos,
        apontamentos,
        setApontamentos,
        listaApontamentosOriginal,
        dynamicSort,
        loadMotivos,
        listaMotivoSelecionado,
        setlistaMotivoSelecionado,
        motivoSelecionado,
        setMotivoSelecionado,
        apontamentoSelecionado,
        setApontamentoSelecionado,
        loading,
        resetApontamentoMotivo,
        setResetApontamentoMotivo,
        listaApontamentosSelecionado,
        setListaApontamentosSelecionado,
        removeMotivo,
        setListaApontamentosOriginal,
        minhasSolicitacoes,
        solicitacoes,
        loadingSolicitacoes,
        solicitacoesParaExibir,
        setSolicitacoesParaExibir,
        loadImoveisDisponiveis,
        listaDeImoveis,
        loadingImoveis,
        imovelSolicitacao,
        setImovelSolicitacao,
        aceiteTermoAgendamento,
        setLoadingSolicitacoes,
        saveFiles, //Thiago
        removeFiles, // Thiago
        removedDocuments, //Thiago
        setRemovedDocuments, //Thiago
        tiposSolicitacoes,
      }}
    >
      {children}
    </ContextSolicitacoes.Provider>
  );
}

export { Solicitacoes, ContextSolicitacoes };
